import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  level: {
    padding: '2px 8px',
    borderRadius: '16px',
    backgroundColor: token.primary.primary2,
    color: token.colorWhite,
    height: 'fit-content',
    lineHeight: 1
  },
  arrow: {
    color: token.grey.grey1,
    fontSize: 16
  },
  userDetails: {
    padding: 20,
    width: 300
  },
  divider: {
    borderColor: token.lightGrey.lightGrey1,
    marginBlock: 24
  },
  logout: {
    cursor: 'pointer'
  },
  profileCard: {
    cursor: 'pointer'
  },
  avatar: {
    fontSize: '48px !important'
  },
  icon: {
    fontSize: 24
  }
}))
